// extracted by mini-css-extract-plugin
export default {"button":"button_button__8UNtd","version2":"button_version2__N619T"};